<template>
  <div>
    <div class="public-lead-heading">
      <div>
        <strong>{{ lead.customer_name || lead.job_type || 'Lead details' }}</strong>
        <div class="public-lead-meta">Lead #{{ lead.lead_id || lead.id }}</div>
      </div>
      <button type="button" class="close-lead" aria-label="Close lead details" @click="$emit('close')"><i class="mdi mdi-close"></i></button>
    </div>
    <div class="public-lead-tabs" role="tablist" aria-label="Lead details">
      <button v-for="option in ['Overview', 'Qualification']" :key="option" type="button" role="tab"
        :class="{ active: tab === option }" :aria-selected="tab === option ? 'true' : 'false'" @click="tab = option">{{ option }}</button>
    </div>
    <div v-show="tab === 'Overview'"><slot /></div>
    <div v-show="tab === 'Qualification'" class="public-qualification">
      <section class="high-value-card">
        <div class="status-heading">
          <div><h3>High Value</h3><p>Indicate whether this lead is valuable to your business.</p></div>
          <v-menu v-model="menu" offset-y bottom left :disabled="saving">
            <template v-slot:activator="{ on, attrs }">
              <button type="button" class="status-edit" v-bind="attrs" v-on="on" :disabled="saving" aria-label="Edit High Value status">
                <high-value-badge :value="lead.is_high_value" /><i class="mdi mdi-pencil-outline" aria-hidden="true"></i>
              </button>
            </template>
            <v-list dense>
              <v-list-item :disabled="saving" @click="saveHighValue(true)"><v-list-item-title>High Value</v-list-item-title><v-icon v-if="lead.is_high_value == 1" small>mdi-check</v-icon></v-list-item>
              <v-list-item :disabled="saving" @click="saveHighValue(false)"><v-list-item-title>Not High Value</v-list-item-title><v-icon v-if="lead.is_high_value != 1" small>mdi-check</v-icon></v-list-item>
            </v-list>
          </v-menu>
        </div>
        <p v-if="saving || notice" role="status" aria-live="polite">{{ saving ? 'Saving qualification…' : notice }}</p>
        <v-alert v-if="error" dense type="error" role="alert">{{ error }}</v-alert>
      </section>
      <lead-conversion-status :lead="lead" :report-uuid="reportUuid" @saved="$emit('saved', $event)" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HighValueBadge from '@/components/common/HighValueBadge.vue'
import LeadConversionStatus from '@/components/common/LeadConversionStatus.vue'

export default {
  name: 'PublicLeadDetails',
  components: { HighValueBadge, LeadConversionStatus },
  props: {
    lead: { type: Object, required: true }, reportUuid: { type: String, required: true },
    initialTab: { type: String, default: 'Overview' }
  },
  data() { return { tab: this.initialTab, menu: false, saving: false, error: '', notice: '' } },
  methods: {
    async saveHighValue(value) {
      if (this.saving) return
      this.menu = false
      this.saving = true
      this.error = ''
      this.notice = ''
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/public-lead-qualification`, {
          report_uuid: this.reportUuid, lead_id: this.lead.id, field: 'high_value', is_high_value: value
        })
        this.$emit('saved', data)
        this.notice = `Saved: ${data.is_high_value ? 'High Value' : 'Not High Value'}.`
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || 'Could not save qualification. Please try again.'
      } finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.public-lead-heading, .status-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.public-lead-heading { color: #111827; margin-bottom: 12px; }
.public-lead-meta { font-size: 12px; color: #6b7280; margin-top: 4px; }
.close-lead { font-size: 20px; padding: 4px 8px; }
.public-lead-tabs { display: flex; gap: 6px; padding: 8px; background: #fafafa; border-bottom: 1px solid #e5e7eb; margin-bottom: 16px; }
.public-lead-tabs button { padding: 6px 12px; border: 1px solid transparent; border-radius: 8px; font-size: 12px; font-weight: 700; color: #374151; }
.public-lead-tabs .active { background: #fff; border-color: #e5e7eb; color: #111827; }
.public-qualification { display: grid; gap: 12px; }
.high-value-card { border: 1px solid #e5e7eb; border-radius: 10px; background: #fff; padding: 16px; }
.high-value-card h3 { margin: 0 0 4px; font-size: 13px; color: #111827; }
.high-value-card p { font-size: 12px; color: #6b7280; margin: 4px 0 0; }
.status-edit { display: inline-flex; align-items: center; gap: 8px; padding: 5px; border: 1px solid transparent; border-radius: 8px; color: #6b7280; }
.status-edit:hover { background: #f9fafb; border-color: #e5e7eb; }
button:focus-visible { outline: 2px solid #276472; outline-offset: 2px; }
button:disabled { opacity: .55; cursor: not-allowed; }
</style>
